import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class TarefasService {
  constructor(private _requestService: RequestService) {}

  createTask(idObra: number, data): Observable<any> {
    const url = `work/${idObra}/set-tasks`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  searchByWork(idObra: number, data: any): Observable<any> {
    const url = `work/Schedule/Search`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  listActions(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Actions`,
      'GET',
      true,
      null
    );
  }

  listResponsables(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null
    );
  }

  editTasks(idTarefa: number, data: any): Observable<any> {
    const url = `work/${idTarefa}/edit-tasks`;
    return this._requestService.requestMethod(url, 'PUT', true, data);
  }

  listTaks(data: any): Observable<any> {
    const url = `work/Schedule/List`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

    deleteTask(payload: {
   tasksID: string 
  }): Observable<any> {
    const url = `work/discard-tasks`;
    return this._requestService.requestMethod(url, 'DELETE', true, payload);
  }

    updateStatusTask(idTask: number, status: number): Observable<any> {
    const url = `work/${idTask}/tasks/set-status/${status}`;
    return this._requestService.requestMethod(url, 'PUT', true);
  }

    modules(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `company/api/Company/GetContractedModules`,
      'GET',
      true,
      null,
      header
    );
  }

   listWorks(): Observable<any> {
    return this._requestService.requestMethod(
      `work/ListWorkOfTask`,
      'GET',
      true,
      null
    );
  }

  
  listWorksEdit(taskId?: number): Observable<any> {
    let url = `work/ListWorkOfTask`;
    if (taskId) {
      url += `?taskId=${taskId}`;
    }
    return this._requestService.requestMethod(url, 'GET', true, null);
  }

}
